import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import { clearLocalStorage } from './analytics';
import { CONSTANTS } from 'constants';

const oas3Api: any = axios.create({
  baseURL: 'https://dev.mesn.arl-nus.org/service',
  headers: {
    'Content-Type': 'application/json'
  }
});

export { oas3Api };

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config: any) => {
    const cookies = new Cookies();
    const tokens = cookies.get('tokens');
    if (tokens) {
      const { accessToken } = tokens;
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers['X-Active-Role'] = 'ROLE_USER';
    return config;
  },
  (err) => Promise.reject(err)
);

let tokenExpiredPromise: Promise<any> | null = null;
let forceTokenPromise: Promise<any> | null = null;

const refreshToken = async (
  originalRequestConfig: AxiosRequestConfig,
  refreshPromise: Promise<any> | null
) => {
  const cookies = new Cookies();
  const tokens = cookies.get('tokens');
  if (tokens) {
    if (!refreshPromise) {
      refreshPromise = axios
        .post(import.meta.env.VITE_API_URL + '/public/refreshAccessToken', {
          refreshToken: tokens.refreshToken
        })
        .then((refreshRes) => {
          //@ts-ignore
          window.myAntsTag('SET', 'userId', userId);
          //@ts-ignore
          window.myAntsTag('EVENT', 'LOGIN');
          cookies.set('tokens', refreshRes.data, {
            path: '/',
            secure: true
          });
          return refreshRes.data;
        })
        .catch((refreshError) => {
          console.error(refreshError);
          cookies.remove('tokens');
          clearLocalStorage();
          window.alert('Token Expired. Please login');
          // @ts-ignore
          window.location = '/login';
          throw refreshError;
        })
        .finally(() => {
          refreshPromise = null;
        });
    }
    try {
      const newData = await refreshPromise;
      // Retry the original request with the new token
      if (!originalRequestConfig.headers) {
        originalRequestConfig.headers = {};
      }

      originalRequestConfig.headers.Authorization = `Bearer ${newData.accessToken}`;
      return axios(originalRequestConfig);
    } catch (err) {
      return Promise.reject(err);
    }
  } else {
    debugger;
    // @ts-ignore
    window.location = '/login';
  }
};

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const status = error.response?.status;
    const data = error.response?.data as { message?: string } | undefined;

    if (status === 401 && data?.message === 'Token Expired') {
      refreshToken(error.config!, tokenExpiredPromise);
    }

    if (status === 409 && data?.message === 'Force Access Token Refresh') {
      refreshToken(error.config!, forceTokenPromise);
    }

    return Promise.reject(error);
  }
);

const getTypedApiData = <T = any>(data: any) => data as T;

// get - latestData
type GetLatestDataResponse = {
  [key: string]: {
    value: unknown;
    unit: unknown;
  };
} & {
  latestTs: string;
};

// post - latestGraphData
type PostLatestGraphDataResponse = Array<{
  qcValue: any;
  timestamp: any;
}>;

export const ROUTES = {
  GET_CONSTANTS: {
    apiPath: `/public/constants`
    // getTypedApiData: getTypedApiData
  },
  GET_LATEST_DATA: {
    apiPath: `/public/latestData/:location`,
    getTypedApiData: getTypedApiData<GetLatestDataResponse>
  },
  POST_LATEST_GRAPH_DATA: {
    apiPath: `/public/latestGraphData`,
    getTypedApiData: getTypedApiData<PostLatestGraphDataResponse>
  }
};

export default api;
